import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import { RevealSection } from '../Animations';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      q: 'How long does implementation take?',
      a: 'Most of our core automation systems are deployed within days or weeks, depending on complexity. We focus on rapid impact.',
    },
    {
      q: 'Do we need a technical team?',
      a: 'No. We handle everything from design to deployment. We also provide training for your existing staff.',
    },
    {
      q: 'Is our data secure?',
      a: 'Absolutely. We prioritize data privacy and can build solutions that run on private servers or within your own cloud environment.',
    },
    {
      q: 'Do you offer ongoing support?',
      a: 'Yes, we provide 24/7 monitoring and support packages to ensure your AI systems continue to run smoothly as your business scales.',
    },
    {
      q: 'Can AI integrate with my existing CRM?',
      a: 'Absolutely. We specialize in connecting AI with popular CRMs like HubSpot, Salesforce, and Pipedrive, as well as custom-built databases.',
    },
  ];

  return (
    <section id="faq" className="section-padding relative">
      <div className="container-custom max-w-4xl">
        <RevealSection className="mb-10 md:mb-14">
          <span className="eyebrow">06. FAQ</span>
          <div className="mt-3 mb-8 h-px bg-white/10" />
          <h2 className="text-[clamp(2rem,4.5vw,3.5rem)] font-display font-semibold text-white leading-[1.05] tracking-[-0.03em]">
            Common questions
          </h2>
        </RevealSection>

        <div className="border-t border-white/10">
          {faqs.map((f, i) => {
            const isOpen = openIndex === i;
            return (
              <div key={i} className="border-b border-white/10">
                <button
                  onClick={() => setOpenIndex(isOpen ? null : i)}
                  className="w-full flex items-center justify-between gap-6 py-6 md:py-7 text-left group"
                  aria-expanded={isOpen}
                >
                  <span className="flex items-center gap-5 text-[17px] md:text-lg font-medium text-white">
                    <span
                      data-mono
                      className="text-[11px] uppercase tracking-[0.12em] text-zinc-500 w-8 shrink-0"
                    >
                      {String(i + 1).padStart(2, '0')}
                    </span>
                    <span className="group-hover:text-[color:var(--color-accent)] transition-colors">
                      {f.q}
                    </span>
                  </span>
                  <span
                    className="shrink-0 w-8 h-8 rounded-full border border-white/15 flex items-center justify-center text-[color:var(--color-accent)] transition-transform duration-200 ease-out"
                    style={{ transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)' }}
                  >
                    <Plus className="w-4 h-4" strokeWidth={1.75} />
                  </span>
                </button>
                <div
                  className="grid overflow-hidden transition-[grid-template-rows] duration-300 ease-out"
                  style={{ gridTemplateRows: isOpen ? '1fr' : '0fr' }}
                >
                  <div className="min-h-0 overflow-hidden">
                    <div className="pb-7 pl-[3.25rem] pr-12 text-zinc-400 leading-relaxed max-w-3xl">
                      {f.a}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
